import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';

// --- STYLED COMPONENTS ---

const SectionWrapper = styled.section`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  background-color: #ffffff;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  color: #439E6D; /* Custom requested theme color */
//   margin-bottom: 40px;
  padding-left: 10px;
`;

const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 60px;
  row-gap: 50px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 40px;
  }
`;

const TestimonialCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const QuoteText = styled.p`
  font-size: 1.05rem;
  color: #334155;
  line-height: 1.6;
//   margin: 0 0 20px 0;
  max-width: 500px;
`;

const AuthorMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
`;

const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorName = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: #0c2340;
`;

const AuthorRole = styled.span`
  font-size: 0.85rem;
  color: #64748b;
`;

// --- MAIN COMPONENT ---

const Testimonials = () => {
  // Testimonial data array with direct extracted writeups and precise layout configurations
  const testimonialsData = [
    {
      id: 1,
      quote: "Working with this company was as satisfying as drinking chilled water. They are particularly exceptional and also very cheap.",
      name: "Joeby Ragpa",
      role: "Business CEO",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150"
    },
    {
      id: 2,
      quote: "I have to say that I have never been so satisfied with any other company as I am with this company. So cheap and excellent. I am out of words to thank this company.",
      name: "Alexander Samokhin",
      role: "Business Investor",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150&h=150"
    },
{
  id: 3,
  quote: "Their team delivered exceptional results with a level of efficiency and professionalism that exceeded our expectations. The quality of service provided at such competitive pricing made them a valuable partner for our operations.",
  name: "Engr. Daniel Briggs",
  role: "Operations Manager, Oil & Gas Company",
  avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150&h=150"
},
{
  id: 4,
  quote: "From project execution to communication, every stage was handled with precision and expertise. Their reliability and cost-effective solutions have made a significant impact on our business performance.",
  name: "Patricia Ekanem",
  role: "Procurement Director, Energy Services Firm",
  avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150&h=150"
}
  ];

  return (
    <SectionWrapper>
      <Fade triggerOnce direction="up" duration={800}>
        <SectionTitle>Satisfied Customers</SectionTitle>
      </Fade>

      <TestimonialsGrid>
        <Fade triggerOnce cascade direction="up" duration={600} fraction={0.1} damping={0.15}>
          {testimonialsData.map((item) => (
            <TestimonialCard key={item.id}>
              <QuoteText>“{item.quote}”</QuoteText>
              <AuthorMeta>
                <Avatar src={item.avatar} alt={item.name} />
                <AuthorInfo>
                  <AuthorName>{item.name}</AuthorName>
                  <AuthorRole>{item.role}</AuthorRole>
                </AuthorInfo>
              </AuthorMeta>
            </TestimonialCard>
          ))}
        </Fade>
      </TestimonialsGrid>
    </SectionWrapper>
  );
};

export default Testimonials;